import { Component, OnInit, ViewEncapsulation, Inject, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
// Import the locale files
import { locale as english } from './i18n/en';
import { locale as spanish } from './i18n/es';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Router } from '@angular/router';
import { DataManagement } from 'app/services/dataManagement';
import { Credenciales } from 'app/models/form.model';
import { DialogModule } from 'app/dialogs/dialog/dialog.module';
import { UtilityProvider } from 'app/providers/utility/utility';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ScrumboardCardDialogComponent } from 'app/main/apps/scrumboard/board/dialogs/card/card.component';
import { ScrumboardService } from 'app/main/apps/scrumboard/scrumboard.service';
import { GlobalService } from 'app/services/globalService';
import { Cookies, Cliente } from 'app/models/data.model';
import { ActivatedRoute } from '@angular/router';
import { RestWS } from 'app/services/restService'

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LoginComponent implements OnInit {

      // CAMARA 

      muestraCamara: boolean = false;
      muestraLogin: boolean = true;
      muestraBuscarCliente: boolean = false;
      contadorCapturas: number = 0;
      muestraManual: boolean = false;
      

      faces: any;

        constraints = {
          video: {
              facingMode: 'user',
              width: { ideal: 300 },
              height: { ideal: 300 }
          },
          videoLogin: {
            facingMode: 'environment',
            width: { ideal: 300 },
            height: { ideal: 300 }
        },
         
        };

       
        videoWidth = 0;
        videoHeight = 0;
        stream: any;
      
        elementType = 'url';  
        public imagePath;  
        value : any;  
        @ViewChild('result') resultElement: ElementRef;  
      
        @ViewChild('video') videoElement: ElementRef;
      
        @ViewChild('canvas') canvas: ElementRef;
        @ViewChild('foto') canvasFoto: ElementRef;
  


    loginForm: FormGroup;
    loading: boolean;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    @ViewChild("email") emailField: ElementRef;
    cookies: Cookies;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        private router: Router,
        private dm: DataManagement,
        private utils: UtilityProvider,
        private globalService: GlobalService,
        private route: ActivatedRoute,
        private api: RestWS,
        private renderer: Renderer2
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        this.translationLoader.loadTranslations(english, spanish);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.loading = true;
        this.globalService.clienteAivoz = null;
        this.globalService.callActual = null;
        this.globalService.campaignActual = null;
        this.globalService.campaigns = null;
        this.globalService.fechaActual = null;
        this.globalService.fechaFinActual = null;

                this.loginForm = this._formBuilder.group({
                    email: ['', [Validators.required, Validators.email]],
                    password: ['', Validators.required],
                    emailBuscar: ['']
                });
                this.loading = false;
          
    }


// CAMARA 

facelogin() {
    this.startCamera();
    this.muestraCamara = true;
    this.contadorCapturas = 0;
}

cancelfacelogin() {
    this.stopvideo();
    this.muestraCamara = false;
    this.contadorCapturas = 0;
    this.muestraManual = true;
}

stopvideo() {
    this.pauseTimer(); 
    try {
     if (this.stream) {
        this.stream.getTracks().forEach(function(track) {
            track.stop();
          });
     }
        
    } finally {

    }
   
    this.muestraCamara = false;
  }

  dataURLtoFile(dataurl, filename) {
 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
  }

  async capture() {
    this.pauseTimer()
    let canvascara = document.createElement("canvas");
    canvascara.height = 300;
    canvascara.width = 300;
    canvascara.getContext('2d').drawImage(this.videoElement.nativeElement, 0, 0);
    this.value = canvascara.toDataURL("image/png")//.replace("image/png", "image/octet-stream");
    setTimeout( async t => {
            var file = await this.dataURLtoFile(this.value, 'uno.png')
            this.api.checkface(file).then( resp => {
                console.log(resp)
                if (resp.faces.length >2) {
                    this.faces = resp.faces;
                    this.stopvideo();
                    this.comprobarFaces();
                    /*if (resp.faces.length > 1) {
                        this.utils.openDialog(this.utils.WARNING, "Escriba su correo para poder confirmar su identidad", false, false);
                        this.pedirCorreo()
                    } else {
                        this.loginCliente(this.faces[0].id)
                    }*/
                } else {
                    this.contadorCapturas ++;
                    if (this.contadorCapturas >= 5) {
                        this.cancelfacelogin();
                        //this.muestraManual = true;
                    }
                    this.startTimer()
                }
            })
      },500);
  

}

comprobarFaces() {
  if (this.faces.length > 3) {
      this.pedirCorreo()
  } else {
    let mismoid = true;
    let id = this.faces[0].id;
    for (let i = 0; i<3; i++) {
        console.log(this.faces[i].id)
        if (this.faces[i].id !== id) mismoid = false;
    }
    if (mismoid) {
        this.loginCliente(this.faces[0].id)
    } else {
        this.utils.openDialog(this.utils.ERROR, "No se ha podido verificar su identidad. Intentelo de nuevo", false, false);
        //this.pedirCorreo();
    }
  }
    
}

pedirCorreo() {
    this.muestraBuscarCliente = true;

}

buscarCliente() {
    let contFaces = 0;
    let mail = this.loginForm.get('emailBuscar').value;
    let found: boolean = false;
    console.log('Email Buscar: ', mail )
    this.api.getClientByEmail(mail).then( cliente => {
        console.log(cliente);
        if (cliente.message.length > 0) {
                let id = cliente.message[0]._id;
                console.log('id: ', id)
                for (let i = 0; i < this.faces.length; i++) {
                    console.log(this.faces[i].id)
                    if (id === this.faces[i].id) {
                            found = true;
                            this.loginCliente(this.faces[i].id)
                    }
                }

                if (!found) {
                    this.utils.openDialog(this.utils.ERROR, "Su identidad no se ha confirmado.", false, false);
                }
            } else {
                this.utils.openDialog(this.utils.ERROR, "Su identidad no se ha confirmado.", false, false);
            }
    })
   
}

loginCliente(id) {
    this.api.getClient(id).then( cliente => {
        console.log('Cliente Smart: ', cliente.cliente)
        this.api.decryptdata('becheckin', cliente.cliente.clave).then( data => {
            console.log('Decrypt: ', data)
            if (data.status === 'ok') {
                this.loginForm.setValue({ 'password': data.message, 'email': cliente.cliente.email , 'emailBuscar': ''});
                this.login();
            } else {

            }
        }).catch( err => {
            console.log('Error decrypt: ', err)
        })
    })
}

startCamera() {
  
    if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) { 
        navigator.mediaDevices.getUserMedia(this.constraints).then(this.attachVideo.bind(this)).catch(this.handleError);
    } else {
        alert('Sorry, camera not available.');
        this.startTimer();
    }
  }
  
  handleError(error) {
  console.log('Error: ', error);
  //this.loading = false;
  }
  
  async attachVideo(stream) {
  
    console.log('atach 1')
    this.stream = stream;
    this.renderer.setProperty(this.videoElement.nativeElement, 'srcObject', stream);
    await this.renderer.listen(this.videoElement.nativeElement, 'play', (event) => {
        this.videoHeight = this.videoElement.nativeElement.videoHeight;
        this.videoWidth = this.videoElement.nativeElement.videoWidth;
        this.capture();
    });
  
  
   //this.startTimer();
   console.log('atach 2')
   
   
  }
  
  timeLeft: number = 1;
  interval;
  
  startTimer() {
      this.interval = setInterval(() => {
        if(this.timeLeft > 1) {
          this.timeLeft--;
          
        } else {
          this.timeLeft = 1;
          console.log('timer')
          //this.textoFace = 'Capturando Imagen'
          this.capture();
        }
      }, 1000)
    }
  
    pauseTimer() {
      clearInterval(this.interval);
    }
  

//





    //////////

    eventHandler(event) {
        if (this.loginForm.get('email').value && this.loginForm.get('password').value && event.keyCode == 13) {
            this.login();
        }
    }

    async login() {
        this.loading = true;
        try {
            let credenciales = new Credenciales();
            credenciales.email = this.loginForm.get('email').value;
            credenciales.clave = this.loginForm.get('password').value;
            let resLogin = await this.dm.login(credenciales);
            if (!resLogin) {
                await this.utils.openDialog(this.utils.ERROR, "Ha ocurrido un error, inténtelo de nuevo", false, false);
                this.loading = false;
                setTimeout(() => {
                    this.emailField.nativeElement.focus();
                }, 100);
            } else if (resLogin.status == 'bad') {
                await this.utils.openDialog(this.utils.ERROR, "El usuario o la contraseña son incorrectos", false, false);
                this.loading = false;
                setTimeout(() => {
                    this.emailField.nativeElement.focus();
                }, 100);
            } else {//if (resLogin.status == 'ok') {
                let clienteAivoz: any = await this.api.getEmpresaByEmail(credenciales.email);
                if (clienteAivoz.status === 'bad') {
                    this.utils.openDialog('Login Error', 'No se puede acceder a la campaña', false, true);
                } else {
                    this.globalService.clienteAivoz = clienteAivoz.message;
                }
            }
                let campaigns = await this.dm.getCampaigns(this.globalService.clienteAivoz);
                this.globalService.campaigns = campaigns.message;
                this.globalService.Admin =  (this.globalService.clienteAivoz.tipo === 0); 

                this.router.navigateByUrl("/apps/documents/events");
        } catch (error) {
            //console.log(error);
            await this.utils.openDialog(this.utils.ERROR, "Ha ocurrido un error, revise su conexión a internet", false, false);
            this.loading = false;
            setTimeout(() => {
                this.emailField.nativeElement.focus();
            }, 100);
        }
    }

comprobarClienteFace(cliente) {

    this.dm.getClienteFacebyEmail(cliente.email).then( clienteFace => {
        console.log(clienteFace)
        if (clienteFace.status === 'ok') {
            console.log('Ya existe en FACE')
            this.api.updateClienteFace(cliente, clienteFace.message._id, cliente.clave).then( cli => {
                console.log(cli);
            })
        } else {
            let body = {
                //nombre: cliente.nombre,
                nombre: cliente.razonSocial,
                organizacion: cliente.cif,
                //organizacion: cliente.razonSocial,
                email: cliente.email,
                pass: cliente.clave
            }
            
            this.dm.createClienteFace(body).then( cliente => {
                console.log('Cliente Face: ', cliente)
            })
        }
    })
}

}
